import type { IconProps } from './types';
import './icons.css';

export default function Dropzone({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 44}
      height={height || 44}
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-edit ${className || ''}`}
      fill="none"
    >
      <path
        d="M6.417 44H35.75c.506 0 .917-.41.917-.917V12.094c.012-.058.036-.115.036-.178
        0-.258-.126-.47-.297-.638-.003-.003-.003-.007-.007-.009l-.105-.104c-.012-.007-.018-.024-.029-.031l-9.033-9.031a.885.885
        0 0 0-.416-.222.865.865 0 0 0-.115-.024c-.04-.005-.077-.024-.118-.024H6.417a.917.917 0 0
        0-.917.917v40.333c0 .506.41.917.917.917ZM27.5 4.963 33.537 11H27.5V4.963ZM7.333 3.667h18.334v8.25c0
        .505.41.916.916.916h8.25v29.334h-27.5v-38.5Z"
        fill="currentColor"
      />
      <path
        d="M27.768 27.767 22 33.537V19.25a.917.917 0 0 0-1.833 0v14.287l-5.768-5.768a.917.917 0 0
        0-1.296 1.297l7.331 7.331a.926.926 0 0 0 1 .2.875.875 0 0 0 .298-.2l7.332-7.331a.917.917 0 0 0-1.296-1.299Z"
        fill="currentColor"
      />
    </svg>
  );
}
